import { render, staticRenderFns } from "./iosdemo.vue?vue&type=template&id=11697540&scoped=true"
import script from "./iosdemo.vue?vue&type=script&lang=js"
export * from "./iosdemo.vue?vue&type=script&lang=js"
import style0 from "./iosdemo.vue?vue&type=style&index=0&id=11697540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11697540",
  null
  
)

export default component.exports